@if (this.currentEnumCustomFormID) {
  <div style="width: 100%; height: 100%;" data-cy="case-form-view-custom-form">
    @if (this.currentEnumCustomFormID === this.customFormTreatment) {
      <app-treatment [caseWorkItemFormsId]="currentCaseWorkItemFormsId" [form]="currentCaseWorkItemForm" data-cy="case-form-view-treatment"></app-treatment>
    }
    @if (this.currentEnumCustomFormID === this.customFormFinalReport) {
      <app-final-report [caseWorkItemFormsId]="currentCaseWorkItemFormsId" data-cy="case-form-view-final-report"></app-final-report>
    }
    @if (this.currentEnumCustomFormID === this.customFormMti) {
      <app-mti [caseWorkItemFormsId]="currentCaseWorkItemFormsId" data-cy="case-form-view-mti"></app-mti>
    }
    @if (this.currentEnumCustomFormID === this.customFormTreatmentPlanning) {
      <app-treatment-planning [caseToothId]="currentToothId" [caseWorkItemFormsId]="currentCaseWorkItemFormsId" data-cy="case-form-view-treatment-planning"></app-treatment-planning>
    }
    @if (this.currentEnumCustomFormID === this.customFormTreatmentPlanApproval) {
      <app-treatment-plan-approval [treatmentPlanId]="currentTreatmentPlanId" data-cy="case-form-view-treatment-plan-approval"></app-treatment-plan-approval>
    }
    @if (this.currentEnumCustomFormID === this.customFormDiagnosis) {
      <app-diagnosis [form]="currentCaseWorkItemForm" [caseWorkItem]="currentCaseWorkItem" [caseWorkItemFormsId]="currentCaseWorkItemFormsId" data-cy="case-form-view-diagnosis"></app-diagnosis>
    }
    @if (this.currentEnumCustomFormID === this.customFormRecall) {
      <app-recall-v2  [currentCaseWorkItemFormsId] = "globals.currentPatientCaseWorkItemFormsID"  [currentCaseId]="globals.currentPatientCaseId" data-cy="case-form-view-recall"></app-recall-v2>
    }
    @if (this.currentEnumCustomFormID === this.customFormPerio) {
      <app-perio [caseWorkItemFormsId]="currentCaseWorkItemFormsId" data-cy="case-form-view-perio"></app-perio>
    }
    @if (this.currentEnumCustomFormID === this.customFormSurgicalDiagnosis) {
      <app-surgical-diagnosis [caseWorkItemFormsId]="currentCaseWorkItemFormsId" [caseWorkItemToothId]="currentToothId" data-cy="case-form-view-surgical-diagnosis"></app-surgical-diagnosis>
    }
    @if (this.currentEnumCustomFormID === this.customFormSurgicalTreatment) {
      <app-surgical-treatment [caseWorkItemFormsId]="currentCaseWorkItemFormsId" [caseWorkItemToothId]="currentToothId" data-cy="case-form-view-surgical-treatment"></app-surgical-treatment>
    }
  </div>
} @else {
  @if (currentCaseWorkItemFormsId) {
    <app-forms-form (onFormCompleted)="formCompleted($event)" [CaseWorkItemFormsId]="currentCaseWorkItemFormsId" actionsEnabled="true" data-cy="case-form-view-standard-form">
    </app-forms-form>
  }
  @if (!currentCaseWorkItemFormsId) {
    <div style="width: 100%; height: 200px; text-align: center; color: var(--tdo-primary); font-size: 24px; font-weight: 500; padding-top: 200px;" data-cy="case-form-view-no-form-message">
      Please select a form<br />
      <img style="width: 300px; margin-top: 20px;" alt="TDO Logo" src="assets/Images/navbar-icons/v2/new_tdo_logo.svg" data-cy="case-form-view-no-form-logo" />
      @if (isDemoWorkstation) {
        <div style="margin-top: 20px;" data-cy="case-form-view-no-form-message-text">The Digital Operating System</div>
      }
    </div>
  }
}

